import { publicEnv } from '@/lib/env';
import { IS_LOCALHOST } from '@/utils/helpers/constants';

export const getWithBaseUrl = (pathname: string) => {
  return `${IS_LOCALHOST ? 'http' : 'https'}://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}${pathname}`;
};
